// Utility to clear comparison data and any corrupted entries

export const clearComparisonData = () => {
  // console.log('[ClearComparison] Current localStorage:', localStorage.getItem('comparison'));
  
  // Remove the comparison data
  localStorage.removeItem('comparison');
  
  // Also check for any corrupted keys
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.includes('comparison') || key.includes('companys')) {
      // console.log(`[ClearComparison] Removing corrupted key: ${key}`);
      localStorage.removeItem(key);
    }
  });
  
  // console.log('[ClearComparison] Comparison data cleared');
  
  // Force a page reload to reset all state
  window.location.reload();
};

// Add to window for easy console access
if (typeof window !== 'undefined') {
  (window as any).clearComparisonData = clearComparisonData;
}